<script setup>
import { ref, reactive, nextTick } from 'vue';
import DialogModal from './DialogModal.vue';
import InputError from './InputError.vue';
import PrimaryButton from './PrimaryButton.vue';
import SecondaryButton from './SecondaryButton.vue';
import TextInput from './TextInput.vue';

const emit = defineEmits(['confirmed']);

defineProps({
    title: {
        type: String,
        default: 'Confirm Password',
    },
    content: {
        type: String,
        default: 'For your security, please confirm your password to continue.',
    },
    button: {
        type: String,
        default: 'Confirm',
    },
});

const confirmingPassword = ref(false);
const currentPasswordInputVisible = ref(false);

const form = reactive({
    password: '',
    error: '',
    processing: false,
});

const passwordInput = ref(null);

const startConfirmingPassword = () => {
    axios.get(route('password.confirmation')).then(response => {
        if (response.data.confirmed) {
            emit('confirmed');
        } else {
            confirmingPassword.value = true;

            setTimeout(() => passwordInput.value.focus(), 250);
        }
    });
};

const confirmPassword = () => {
    form.processing = true;

    axios.post(route('password.confirm'), {
        password: form.password,
    }).then(() => {
        form.processing = false;

        closeModal();
        nextTick().then(() => emit('confirmed'));

    }).catch(error => {
        form.processing = false;
        form.error = error.response.data.errors.password[0];
        passwordInput.value.focus();
    });
};

const closeModal = () => {
    confirmingPassword.value = false;
    form.password = '';
    form.error = '';
};
</script>

<template>
    <span>
        <span @click="startConfirmingPassword">
            <slot />
        </span>
        <v-dialog v-model="confirmingPassword" width="auto" @afterLeave="closeModal">
            <v-card max-width="100%" width="600">
                <v-card-title>{{ title }}</v-card-title>
                <v-card-text>
                    <div class="fs-n1 text-secondary pb-4">{{ content }}</div>
                    <div class="">
                        <v-text-field
                            label="Password"
                            size="small"
                            v-model="form.password"
                            ref="currentPasswordInput"
                            :type="currentPasswordInputVisible ? 'text' : 'password'"
                            placeholder="Enter your password"
                            variant="outlined"
                            :error-messages="form.error"
                            density="comfortable"
                            hide-details
                        >
                            <template #append-inner >
                                <span role="button" @click="currentPasswordInputVisible = !currentPasswordInputVisible">
                                    <mdi-icon v-if="currentPasswordInputVisible">visibility_off</mdi-icon>
                                    <mdi-icon v-else>visibility</mdi-icon>
                                </span>
                            </template>
                        </v-text-field>
                    </div>
                </v-card-text>
                <v-card-actions-form-modal>
                    <v-btn
                        text="Cancel"
                        color="btn-secondary"
                        @click="closeModal"
                    ></v-btn>
                    <v-btn
                        :disabled="form.processing"
                        :loading="form.processing"
                        @click="confirmPassword"
                        text="Confirm"
                    ></v-btn>
                </v-card-actions-form-modal>
            </v-card>
        </v-dialog>
    </span>
</template>
